import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import PageTypeUtils from 'app/utils/pageType';
import SelectSocialTypeOption from './selectNewProfileType/SelectSocialTypeOption';
import SimpleGrid from 'app/components/SimpleGrid';
import NewManualProfileCard from './NewManualProfileCard';

export type SelectNewProfileTypeProps = {
  socialMediaTypes: number[];
  manualSocialMediaTypes?: number[];
  onSelectSocialMediaType: (type: number) => void;
  openManualForm?: (type?: number) => void;
  dataNamePrefix?: {
    socialTypeOption?: string;
  };
};

const SelectNewProfileType: FC<SelectNewProfileTypeProps> = ({
  openManualForm,
  socialMediaTypes,
  manualSocialMediaTypes,
  onSelectSocialMediaType,
  dataNamePrefix,
}) => {
  const { t } = useTranslation();
  return (
    <div>
      <SimpleGrid columns={3} gap={8}>
        {socialMediaTypes.map((type) => (
          <SelectSocialTypeOption
            key={type}
            type={type}
            onClick={() => onSelectSocialMediaType(type)}
            dataName={
              dataNamePrefix?.socialTypeOption
                ? `${dataNamePrefix?.socialTypeOption}${PageTypeUtils.getName(
                    type,
                  )}`
                : undefined
            }
          />
        ))}
      </SimpleGrid>
      {!!manualSocialMediaTypes && (
        <div className="tw-mt-4 tw-rounded-md tw-bg-grayscale-5 tw-p-4">
          <h3 className="tw-text-md tw-font-semibold">
            {t('newSocialMediaProfile.orCreateMockupProfile')}
          </h3>
          <p className="tw-text-sm tw-text-grayscale-180">
            {t('newSocialMediaProfile.publishingWarning')}
          </p>
          <div className="tw-mt-4 tw-space-y-2">
            {manualSocialMediaTypes.map((type) => (
              <NewManualProfileCard
                key={type}
                type={type}
                openManualForm={openManualForm}
                dataCy={`create-new-profile-button-manually`}
                dataName={
                  dataNamePrefix?.socialTypeOption
                    ? `${
                        dataNamePrefix?.socialTypeOption
                      }${PageTypeUtils.getName(type)}_manually`
                    : undefined
                }
              />
            ))}
            <NewManualProfileCard
              type="other"
              openManualForm={openManualForm}
              dataCy={`create-new-profile-button-manually`}
              dataName={
                dataNamePrefix?.socialTypeOption
                  ? `${dataNamePrefix?.socialTypeOption}_manually`
                  : undefined
              }
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default SelectNewProfileType;
